import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import { CorporateCreatePage } from 'src/components/enterprise/features/Corporate/CreatePage/CorporateCreatePage';
import { CorporateEditPage } from 'src/components/enterprise/features/Corporate/EditPage/CorporateEditPage';
import { CorporatePaths } from 'src/components/AppRoutes/Enterprise/CorporatePaths';

export const CorporateRoutes = (): JSX.Element => {
  const CorporateCreatePageLayout = withEnterpriseLayout(CorporateCreatePage);
  const CorporateEditPageLayout = withEnterpriseLayout(CorporateEditPage);

  return (
    <Switch>
      <Route
        exact
        path={CorporatePaths.create}
        component={(): ReactElement => (
          <CorporateCreatePageLayout pageTitle="Add New Client" />
        )}
      />
      <Route
        exact
        path={CorporatePaths.edit}
        component={(): ReactElement => (
          <CorporateEditPageLayout pageTitle="Edit Client" />
        )}
      />
    </Switch>
  );
};
